import { render, staticRenderFns } from "./LinkedinLogin.vue?vue&type=template&id=4f89473f&"
import script from "./LinkedinLogin.vue?vue&type=script&lang=js&"
export * from "./LinkedinLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports